export const sorter = (list, sorterProp = "name") =>
  list.sort((a, b) => a[sorterProp]?.localeCompare(b[sorterProp]));
